import React from 'react';
import { Step } from 'semantic-ui-react';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

type StepAssistenzaProps = {
    stepAttuale: number,
    firstStepDescription: string,
    onClick: (step: number) => void
}

export default class StepAssistenza extends React.Component<StepAssistenzaProps> {

    render() {
        const { stepAttuale, onClick, firstStepDescription } = this.props;

        return (
            <>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Step.Group as={Media} ordered greaterThanOrEqual="computer">
                        <Step active={stepAttuale === 0} completed={stepAttuale > 0} onClick={() => onClick(0)}>
                            <Step.Content>
                                <Step.Title>Selezione</Step.Title>
                                <Step.Description>{firstStepDescription}</Step.Description>
                            </Step.Content>
                        </Step>
                        <Step active={stepAttuale === 1} completed={stepAttuale > 1} onClick={() => onClick(1)}>
                            <Step.Content>
                                <Step.Title>Segnalazione</Step.Title>
                                <Step.Description>Scegli la richiesta</Step.Description>
                            </Step.Content>
                        </Step>
                        <Step active={stepAttuale === 2}>
                            <Step.Content>
                                <Step.Title>Conferma</Step.Title>
                                <Step.Description>Verifica e invia</Step.Description>
                            </Step.Content>
                        </Step>
                    </Step.Group>
                </MediaContextProvider>
            </>
        );
    }
}